import React from 'react';
import { Theme } from '../../../../../../Enums/Theme.enum';
import LinkButton from '../../../../../../Components/Button/LinkButton';
import MedicalHistoryConfigCreateModal from './MedicalHistoryConfigCreateModal';
import styles from './MedicalHistoryConfigControls.module.scss';
import { useDisclose } from '../../../../../Modal/Hooks/useDisclose';

interface Props {
	onCreate: () => void;
}

const MedicalHistoryConfigControls: React.FC<Props> = ({ onCreate }) => {
	const { isOpen, onOpen, onClose } = useDisclose();

	const handleOnCreate = () => {
		onClose();
		onCreate();
	};

	return (
		<div className={styles.wrapper}>
			<LinkButton
				title='component.medicalHistoryConfig.addItem'
				theme={Theme.BLUE}
				onClick={onOpen}
			/>
			{isOpen && (
				<MedicalHistoryConfigCreateModal
					isOpen
					onClose={onClose}
					onCreate={handleOnCreate}
				/>
			)}
		</div>
	);
};

export default MedicalHistoryConfigControls;
